import { render, staticRenderFns } from "./integralShopRule.vue?vue&type=template&id=93cf2f5c&scoped=true"
import script from "./integralShopRule.vue?vue&type=script&lang=js"
export * from "./integralShopRule.vue?vue&type=script&lang=js"
import style0 from "./integralShopRule.vue?vue&type=style&index=0&id=93cf2f5c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93cf2f5c",
  null
  
)

export default component.exports